import * as React from 'react'

import { ReactComponent as InfoPurpleIcon } from '../../../Assets/infoPurple.svg'
import { ReactComponent as InfoTealIcon } from '../../../Assets/infoTeal.svg'
import { ReactComponent as WarningIcon } from '../../../Assets/warning.svg'
import Headings from '../../atoms/Heading'
import Paragraph from '../../atoms/Paragraph'
import BannerNotification from '../BannerNotification'

interface Props {
  background: string
  content?: any
}

/**
 * Alert Component
 * @param content - Content from the CMS.
 * @param background - Background of the Alert. Expected values: "teal" | "purple" | "orange", Default: "teal"
 */
const Alert = ({ background = 'teal', content }: Props) => {
  background = background.toLowerCase()
  const bgColor =
    background === 'purple'
      ? 'bg-purple-100'
      : background === 'orange'
        ? 'bg-orange-10'
        : background === 'teal'
          ? 'bg-teal-10'
          : background === 'lightpurple'
            ? 'bg-purple-10'
            : 'bg-white'
  const borderColor =
    background === 'purple'
      ? 'border-purple-100'
      : background === 'orange'
        ? 'border-orange-100'
        : background === 'teal'
          ? 'border-teal-100'
          : background === 'lightpurple'
            ? 'border-purple-100'
            : 'border-none'

  return (
    <>
      {content?.fields?.bannerNotification && <BannerNotification content={content} background={background} />}
      {!content?.fields?.bannerNotification && (
        <div className="layoutSpacing in-pagealerts">
          <div
            className={`w-100 ${content?.fields?.containerBottomSpacing ? 'sectionBottomSpacing' : ''} layout`}
            data-testid="alert"
          >
            <div className={`rounded-2xl border p-32 ${bgColor} ${borderColor}`}>
              <div className="flex items-start gap-32">
                <div className="min-w-[32px]">
                  {background === 'orange' && <WarningIcon />}
                  {background === 'teal' && <InfoTealIcon />}
                  {background === 'lightpurple' && <InfoPurpleIcon />}
                </div>
                <div>
                  <Headings variant="H4" content={content?.fields?.title} classes="text-black mb-8" />
                  <Paragraph content={content?.fields?.message} classes="!text-base md:!text-md !pb-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Alert
